import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import banner from 'model/banner';
import product from 'model/product';
import news from 'model/news';
import category from 'model/category';
import cart from 'model/cart';
import order from 'model/order';
import contact from 'model/contact';
import alert from 'model/alert';
import confirm from 'model/confirm';
import bonus from 'model/bonus';
import auth from 'model/auth';
import filter from 'model/filter';
import user from 'model/user';
import coupon from 'model/coupon';

const reducers = combineReducers({
	routing: routerReducer,
	...banner.reducer,
	...product.reducer,
	...news.reducer,
	...category.reducer,
	...cart.reducer,
	...order.reducer,
	...contact.reducer,
	...alert.reducer,
	...confirm.reducer,
	...bonus.reducer,
	...auth.reducer,
	...filter.reducer,
	...user.reducer,
	...coupon.reducer,
});

export default reducers;
